'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_TRANSLATIONS_ENDPOINT = exports.CMS_CONFIGURATIONS_ID = exports.SERVER_SIDE_PATH = exports.CONTENT_PATH = exports.NAME = undefined;

var _utils = require('../endpoints/utils');

var NAME = exports.NAME = 'translationsManagementnpm';

var CONTENT_PATH = exports.CONTENT_PATH = 'data.configuration.content';

var SERVER_SIDE_PATH = exports.SERVER_SIDE_PATH = 'i18n.serverSideContent';

var CMS_CONFIGURATIONS_ID = exports.CMS_CONFIGURATIONS_ID = 'ALL_CONTENT';

var GET_TRANSLATIONS_ENDPOINT = exports.GET_TRANSLATIONS_ENDPOINT = (0, _utils.getConfigurationServiceEndpoint)() + '/configurations/' + CMS_CONFIGURATIONS_ID + '?type=referenceKey';